<!--
 * @Description: 学生 详情 学期评语
 * @Author: PF
 * @Date: 2023-11-30 10:50:08
 * @LastEditors: PF
 * @LastEditTime: 2025-07-16 13:35:39
-->
<template>
  <ul class="xqpy-page" v-if="tableData.length">
    <li v-for="(item, index) in tableData" :key="index">
      <p>{{ item.py }}</p>
      <span>{{ item.dprq }}</span>
    </li>
  </ul>
  <el-empty v-else class="hp100" description="暂无评语" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/xuesheng/banzhurengongzuoxueqipingyu/list', data: tableData, parms: { xsid: props.row.id, order: 'dprq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
  .xqpy-page{
    li {
      border: 1px solid #e7e7e7;
      border-radius: 10px;
      padding: 10px;
      margin-top: 10px;
      text-indent: 4ch;
      p {
        margin-bottom: 10px;
      }
      span {
        color: #909399;
      }
    }
  }
</style>